import { render, staticRenderFns } from "./ItsSalesDepartDetail.vue?vue&type=template&id=4b3ff5ea&scoped=true&"
import script from "./ItsSalesDepartDetail.vue?vue&type=script&lang=js&"
export * from "./ItsSalesDepartDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesDepartDetail.vue?vue&type=style&index=0&id=4b3ff5ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ff5ea",
  null
  
)

export default component.exports